var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormSelect',_vm._g(_vm._b({attrs:{"options":_vm.countryList},scopedSlots:_vm._u([{key:"option",fn:function(ref){
var option = ref.option;
return [_c('img',{staticStyle:{"margin-right":".5rem"},attrs:{"src":_vm.getCountryFlag(option.alpha2Code),"width":"16","height":"16","alt":option.name}}),_vm._v(" "+_vm._s(option.name)+" ")]}}])},'FormSelect',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }